import { authContext } from 'contexts/'
import { LocationDescriptor } from 'history'
import { useContext, useEffect, useState } from 'react'
import { Redirect, useLocation } from 'react-router'
import { IPrivateGuardProps } from './private-guard-props.interface'

const CompleteRegGuard: React.FC<IPrivateGuardProps> = ({ children }) => {
  const auth = useContext(authContext)
  const { pathname, search } = useLocation()
  const [redirectToLogin, setRedirectToLogin] = useState<boolean>(
    !((!!auth?.user && auth?.getUserData()?.tipoProfilo.id !== 'X') || !auth?.user),
  )
  const [redirectTo] = useState<LocationDescriptor>({
    pathname: '/complete-reg',

    state: { from: pathname },
  })

  useEffect(() => {
    if (!!auth?.user && auth?.getUserData()?.tipoProfilo.id !== 'X') {
      setRedirectToLogin(false)
    }
  }, [auth, auth?.user])

  return redirectToLogin ? <Redirect to={redirectTo ?? '/'} /> : <> {children}</>
}

export default CompleteRegGuard
